import React from 'react';
import { Heart, Gift, Shield, Sparkles, ArrowRight } from 'lucide-react';
import { Button } from '../ui/button';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';

const ZeroFeeBanner = () => {
  const { t } = useLanguage();

  return (
    <section className="py-12 bg-gradient-to-r from-emerald-500/10 via-emerald-500/10 to-teal-500/10 relative overflow-hidden">
      {/* Background decorations */}
      <div className="absolute inset-0 opacity-30">
        <div className="absolute top-0 left-1/4 w-64 h-64 bg-emerald-500/20 rounded-full blur-3xl" />
        <div className="absolute bottom-0 right-1/4 w-64 h-64 bg-teal-500/20 rounded-full blur-3xl" />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8">
          {/* Main Badge */}
          <div className="inline-flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-emerald-500 to-emerald-500 rounded-full text-white font-bold text-lg mb-6 shadow-lg shadow-emerald-500/25">
            <Gift className="w-6 h-6" />
            <span>{t('zeroPlatformFee')}</span>
            <Sparkles className="w-5 h-5" />
          </div>

          <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
            {t('donationGoesToCause')}
          </h2>
          <p className="text-lg text-foreground/70 max-w-2xl mx-auto">
            {t('zeroFeeSubtitle')}
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid md:grid-cols-3 gap-6 mb-8">
          <div className="bg-card/50 backdrop-blur-sm border border-border rounded-2xl p-6 text-center hover:border-emerald-500/50 transition-colors">
            <div className="w-14 h-14 bg-emerald-500/20 rounded-2xl flex items-center justify-center mx-auto mb-4">
              <Heart className="w-7 h-7 text-emerald-500" />
            </div>
            <h3 className="font-semibold text-foreground mb-2">{t('noHiddenFeesTitle')}</h3>
            <p className="text-sm text-foreground/70">
              {t('noHiddenFeesDesc')}
            </p>
          </div>

          <div className="bg-card/50 backdrop-blur-sm border border-border rounded-2xl p-6 text-center hover:border-emerald-500/50 transition-colors">
            <div className="w-14 h-14 bg-emerald-500/20 rounded-2xl flex items-center justify-center mx-auto mb-4">
              <Gift className="w-7 h-7 text-emerald-500" />
            </div>
            <h3 className="font-semibold text-foreground mb-2">{t('optionalTipsTitle')}</h3>
            <p className="text-sm text-foreground/70">
              {t('optionalTipsDesc')}
            </p>
          </div>

          <div className="bg-card/50 backdrop-blur-sm border border-border rounded-2xl p-6 text-center hover:border-teal-500/50 transition-colors">
            <div className="w-14 h-14 bg-teal-500/20 rounded-2xl flex items-center justify-center mx-auto mb-4">
              <Shield className="w-7 h-7 text-teal-500" />
            </div>
            <h3 className="font-semibold text-foreground mb-2">{t('fullTransparencyTitle')}</h3>
            <p className="text-sm text-foreground/70">
              {t('fullTransparencyDesc')}
            </p>
          </div>
        </div>

        {/* CTA */}
        <div className="text-center">
          <p className="text-foreground/70 mb-4">
            {t('generosityPowersHope')}
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <Link to="/discover">
              <Button className="bg-gradient-to-r from-emerald-500 to-emerald-500 hover:from-emerald-600 hover:to-emerald-600 text-white px-8">
                {t('donateNow')} <ArrowRight className="w-4 h-4 ml-2" />
              </Button>
            </Link>
            <Link to="/create">
              <Button variant="outline" className="border-emerald-500/50 text-emerald-500 hover:bg-emerald-500/10">
                {t('startCampaign')}
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ZeroFeeBanner;
